import UploadInstructions from './UploadInstructions';
import Title from './Title';

const RulesBulkUpload = { Title, UploadInstructions };

export default RulesBulkUpload;
